import Utils from '../../../utils/Utils';

import UserStore from '../../../stores/UserStore';
import ConfigStore from '../../../stores/ConfigStore';

import { endPoints as GuestEndPoints } from '../../../constants/GuestConstants';
import { endPoints as GuestListEndPoints } from '../../../constants/GuestListConstants';
import AjaxPromises from '../../../utils/AjaxPromises';

import NotificationActions from '../../../actions/NotificationActions';
import GuestActions from '../../../actions/GuestActions';
import GuestStore from '../../../stores/GuestStore';

import InputProfile from './InputProfile.react';
import DropdownProfile from './DropdownProfile.react';
import DOBProfile from './DOBProfile.react';
import TextareaProfile from './TextareaProfile.react';
import DOB from '../../form/DOB.react';
import Header from './Header.react';
import TextInput from '../../form/input/Input.react';

import DD from '../../form/dropdown/DD.react';
import Picklist from '../../form/picklist/Picklist.react';
import PageHeader from '../../form/layout/PageHeader.react';
import PageRow from '../../form/layout/PageRow.react';
import Prescriptions from './Prescriptions.react';
import moment from 'moment';
import DropdownProfileStates from './DropdownProfileStates';

const CustomerProfilePOS = 'Customer Profile (POS)';

class ViewMedical extends React.Component {

    constructor(props) {
        super(props);

        var guest = this.props.guest;

        this.state = {
            doctor              : parseInt(guest.doctor),

            // Primary Care Giver
            CGFirstName             : guest.CGFirstName,
            CGLastName              : guest.CGLastName,
            CaregiverMJStateIdNo    : guest.CaregiverMJStateIdNo,
            CaregiverPhone          : guest.CaregiverPhone,
            CaregiverDOB            : guest.CaregiverDOB.length > 0 ? moment(guest.CaregiverDOB).format('YYYY-MM-DD') : '',
            CaregiverStartDate      : guest.CaregiverStartDate.length > 0 ? moment(guest.CaregiverStartDate).format('YYYY-MM-DD') : '',
            CaregiverExpirationDate : guest.CaregiverExpirationDate.length > 0 ? moment(guest.CaregiverExpirationDate).format('YYYY-MM-DD') : '',
            CaregiverRelationship   : guest.CaregiverRelationship,
            CaregiverAddress        : guest.CaregiverAddress,
            CaregiverAddress2       : guest.CaregiverAddress2,
            CaregiverAddress3       : guest.CaregiverAddress3,
            CaregiverCity           : guest.CaregiverCity,
            CaregiverState          : guest.CaregiverState,
            CaregiverPostalCode     : guest.CaregiverPostalCode,
            
            // Additional Care Givers
            caregiverName2          : guest.CaregiverName2,
            caregiverDOB2           : guest.CaregiverDOB2,
            CaregiverRelationship2  : guest.CaregiverRelationship2,
            CaregiverMJStateIdNo2            : guest.CaregiverMJStateIdNo2,
            caregiverPhone2         : guest.CaregiverPhone2,

            caregiverName3          : guest.CaregiverName3,
            CaregiverRelationship3  : guest.CaregiverRelationship3,
            caregiverDOB3           : guest.CaregiverDOB3,
            CaregiverMJStateIdNo3   : guest.CaregiverMJStateIdNo3,
            caregiverPhone3         : guest.CaregiverPhone3,

            caregiverName4          : guest.CaregiverName4,
            caregiverDOB4           : guest.CaregiverDOB4,
            CaregiverMJStateIdNo4   : guest.CaregiverMJStateIdNo4,
            caregiverPhone4         : guest.CaregiverPhone4,
            CaregiverRelationship4  : guest.CaregiverRelationship4,

            caregiverName5          : guest.CaregiverName5,
            caregiverDOB5           : guest.CaregiverDOB5,
            CaregiverMJStateIdNo5   : guest.CaregiverMJStateIdNo5,
            caregiverPhone5         : guest.CaregiverPhone5,
            CaregiverRelationship5  : guest.CaregiverRelationship5,

            caregiverName6          : guest.CaregiverName6,
            caregiverDOB6           : guest.CaregiverDOB6,
            CaregiverMJStateIdNo6   : guest.CaregiverMJStateIdNo6,
            caregiverPhone6         : guest.CaregiverPhone6,
            CaregiverRelationship6  : guest.CaregiverRelationship6,

            attestation                 : guest.Attestation.toLowerCase(),
            attestationSignedDate       : guest.AttestationSignedDate ? moment(guest.AttestationSignedDate).format('YYYY-MM-DD') : '',
            attestationExpirationDate   : guest.AttestationExpirationDate ? moment(guest.AttestationExpirationDate).format('YYYY-MM-DD') : '',

            caregiverEmail      : guest.CaregiverEmail,
            caregiverEmail1     : guest.CaregiverEmail1,
            caregiverEmail2     : guest.CaregiverEmail2,
            caregiverEmail3     : guest.CaregiverEmail3,
            caregiverEmail4     : guest.CaregiverEmail4,
            caregiverEmail5     : guest.CaregiverEmail5,
            caregiverEmail6     : guest.CaregiverEmail6,

            caregiverNotes      : guest.CaregiverNotes,
            caregiverNotes2     : guest.CaregiverNotes2,
            caregiverNotes3     : guest.CaregiverNotes3,
            caregiverNotes4     : guest.CaregiverNotes4,
            caregiverNotes5     : guest.CaregiverNotes5,
            caregiverNotes6     : guest.CaregiverNotes6,

            notes               : guest.notes.replace('\r\n', '\\r\\n'),
            creditNote          : guest.CreditNote.replace('\r\n', '\\r\\n'),
            guardian            : guest.Guardian,
            conditions          : guest.Conditions.replace('\r\n', '\\r\\n'),
            list_of_doctors     : [],
            
            PrimaryQualifyingConditionId : guest.PrimaryQualifyingConditionId,
            SecondaryQualifyingConditionIds : guest.SecondaryQualifyingConditionIds || [],

            list_of_all_qualified_conditions : [],
            list_of_primary_qualified_conditions : [],
            list_of_secondary_qualified_conditions : [],

            documents           : [],
            managePrescriptions : false,
        };

        this.onChange = this.onChange.bind(this);
        this.getFormData = this.getFormData.bind(this);
        this.getDoctorByTitle = this.getDoctorByTitle.bind(this);
        this.onAttestationChange = this.onAttestationChange.bind(this);
        this.setPrimary = this.setPrimary.bind(this);
        this.isCollectorValid = this.isCollectorValid.bind(this);
        this.onGuestStoreChange = this.onGuestStoreChange.bind(this);
        this.updateGuest = this.updateGuest.bind(this);
        this.viewPrescriptions = this.viewPrescriptions.bind(this);
        this.getErrors = this.getErrors.bind(this);
    }

    componentWillMount() {
        GuestStore.addChangeListener(this.onGuestStoreChange);
    }

    componentWillUnmount() {
        GuestStore.removeChangeListener(this.onGuestStoreChange);
    }

    onGuestStoreChange() {
        this.updateGuest(GuestStore.getGuestById(this.props.guest.Guest_id));
    }

    getErrors() {
        var validationError = UserStore.getFormError(CustomerProfilePOS, this.state);

        if (validationError) {
            return validationError;
        }

        return false;
    }

    updateGuest(guest) {
        this.setState({
            doctor              : parseInt(guest.doctor),

            // Primary Care Giver
            CGFirstName             : guest.CGFirstName,
            CGLastName              : guest.CGLastName,
            CaregiverMJStateIdNo    : guest.CaregiverMJStateIdNo,
            CaregiverPhone          : guest.CaregiverPhone,
            CaregiverDOB            : guest.CaregiverDOB.length > 0 ? moment(guest.CaregiverDOB).format('YYYY-MM-DD') : '',
            CaregiverStartDate      : guest.CaregiverStartDate.length > 0 ? moment(guest.CaregiverStartDate).format('YYYY-MM-DD') : '',
            CaregiverExpirationDate : guest.CaregiverExpirationDate.length > 0 ? moment(guest.CaregiverExpirationDate).format('YYYY-MM-DD') : '',
            CaregiverRelationship   : guest.CaregiverRelationship,

            caregiverName2          : guest.CaregiverName2,
            caregiverDOB2           : guest.CaregiverDOB2,
            CaregiverRelationship2  : guest.CaregiverRelationship2,
            CaregiverMJStateIdNo2   : guest.CaregiverMJStateIdNo2,
            caregiverPhone2         : guest.CaregiverPhone2,

            caregiverName3          : guest.CaregiverName3,
            CaregiverRelationship3  : guest.CaregiverRelationship3,
            caregiverDOB3           : guest.CaregiverDOB3,
            CaregiverMJStateIdNo3   : guest.CaregiverMJStateIdNo3,
            caregiverPhone3         : guest.CaregiverPhone3,

            caregiverName4          : guest.CaregiverName4,
            CaregiverRelationship4  : guest.CaregiverRelationship4,
            caregiverDOB4           : guest.CaregiverDOB4,
            CaregiverMJStateIdNo4   : guest.CaregiverMJStateIdNo4,
            caregiverPhone4         : guest.CaregiverPhone4,

            caregiverName5          : guest.CaregiverName5,
            CaregiverRelationship5  : guest.CaregiverRelationship5,
            caregiverDOB5           : guest.CaregiverDOB5,
            CaregiverMJStateIdNo5   : guest.CaregiverMJStateIdNo5,
            caregiverPhone5         : guest.CaregiverPhone5,

            CaregiverRelationship6  : guest.CaregiverRelationship6,
            caregiverName6          : guest.CaregiverName6,
            caregiverDOB6           : guest.CaregiverDOB6,
            CaregiverMJStateIdNo6   : guest.CaregiverMJStateIdNo6,
            caregiverPhone6         : guest.CaregiverPhone6,

            attestation                   : guest.Attestation.toLowerCase(),
            attestationSignedDate         : guest.AttestationSignedDate ? moment(guest.AttestationSignedDate).format('YYYY-MM-DD') : '',
            attestationExpirationDate     : guest.AttestationExpirationDate ? moment(guest.AttestationExpirationDate).format('YYYY-MM-DD') : '',

            caregiverEmail      : guest.CaregiverEmail,
            caregiverEmail1     : guest.CaregiverEmail1,
            caregiverEmail2     : guest.CaregiverEmail2,
            caregiverEmail3     : guest.CaregiverEmail3,
            caregiverEmail4     : guest.CaregiverEmail4,
            caregiverEmail5     : guest.CaregiverEmail5,
            caregiverEmail6     : guest.CaregiverEmail6,

            caregiverNotes      : guest.CaregiverNotes,
            caregiverNotes2     : guest.CaregiverNotes2,
            caregiverNotes3     : guest.CaregiverNotes3,
            caregiverNotes4     : guest.CaregiverNotes4,
            caregiverNotes5     : guest.CaregiverNotes5,
            caregiverNotes6     : guest.CaregiverNotes6,

            notes               : guest.notes.replace('\r\n', '\\r\\n'),
            creditNote          : guest.CreditNote.replace('\r\n', '\\r\\n'),
            guardian            : guest.Guardian,
            conditions          : guest.Conditions.replace('\r\n', '\\r\\n'),
            
            PrimaryQualifyingConditionId : guest.PrimaryQualifyingConditionId,
            SecondaryQualifyingConditionIds : guest.SecondaryQualifyingConditionIds || [],
        });
    }

    componentDidMount() {
        this.loadListOfDoctors();
        this.loadQualifiedConditions();
    }

    loadListOfDoctors(notify) {
        var self = this;
        var formData = UserStore.getApiData();

        AjaxPromises.POST(GuestEndPoints.GET_DOCTOR_LIST,
            formData).then(res => {
                if (notify) {
                    NotificationActions.success('List of doctors re-loaded');
                }
                
                
                if(res.Result) {
                    self.setState({
                        list_of_doctors : res.Data ? res.Data : []
                    });
                } else if(!res.Result) {
                    NotificationActions.error(`Failed to load doctors list: ${res.Message}`);
                }
            }
        );
    }
    
    loadQualifiedConditions(notify) {
        var self = this;
        var formData = UserStore.getApiData();

        AjaxPromises.POST(GuestEndPoints.GET_QUALIFIED_CONDITIONS,
            formData).then(res =>{

            var list_of_all_qualified_conditions = res.Data ? res.Data : [];
            var list_of_primary_qualified_conditions = list_of_all_qualified_conditions.filter(qc => qc.IsDeleted == 0 && qc.IsPrimary == 1);
            var list_of_secondary_qualified_conditions = list_of_all_qualified_conditions.filter(qc => qc.IsDeleted == 0 && qc.IsSecondary == 1);

            self.setState({
                list_of_all_qualified_conditions,
                list_of_primary_qualified_conditions,
                list_of_secondary_qualified_conditions
            });

            if (notify)
                NotificationActions.success('List of Qualified Conditions re-loaded');
        });
    }

    onChange(field, val) {
        this.setState({ [field] : val });
    }

    getFormData(formData) {
        formData.DoctorsName = this.state.doctor.toString();
        formData.notes = this.state.notes;
        formData.CreditNote = this.state.creditNote;
        formData.Conditions = this.state.conditions;

        formData.CGFirstName = this.state.CGFirstName;
        formData.CGLastName = this.state.CGLastName;
        formData.CaregiverMJStateIdNo = this.state.CaregiverMJStateIdNo;
        formData.CaregiverDOB = this.state.CaregiverDOB.length > 0 ? this.state.CaregiverDOB : null;
        formData.CaregiverRelationship = this.state.CaregiverRelationship;
        formData.CaregiverPhone = this.state.CaregiverPhone;
        formData.CaregiverEmail = this.state.caregiverEmail;
        formData.CaregiverNotes = this.state.caregiverNotes;

        formData.CaregiverStartDate = this.state.CaregiverStartDate.length > 0 ? this.state.CaregiverStartDate : null;
        formData.CaregiverExpirationDate = this.state.CaregiverExpirationDate.length > 0 ? this.state.CaregiverExpirationDate : null;
        
        formData.CaregiverAddress = this.state.CaregiverAddress;
        formData.CaregiverAddress2 = this.state.CaregiverAddress2;
        formData.CaregiverAddress3 = this.state.CaregiverAddress3;
        formData.CaregiverCity = this.state.CaregiverCity;
        formData.CaregiverState = this.state.CaregiverState;
        formData.CaregiverPostalCode = this.state.CaregiverPostalCode;

        formData.CaregiverName2 = this.state.caregiverName2;
        formData.CaregiverMJStateIdNo2 = this.state.CaregiverMJStateIdNo2;
        formData.CaregiverDOB2 = this.state.caregiverDOB2;
        formData.CaregiverRelationship2 = this.state.CaregiverRelationship2;
        formData.CaregiverPhone2 = this.state.caregiverPhone2;
        formData.CaregiverEmail2 = this.state.caregiverEmail2;
        formData.CaregiverNotes2 = this.state.caregiverNotes2;

        formData.CaregiverName3 = this.state.caregiverName3;
        formData.CaregiverMJStateIdNo3 = this.state.CaregiverMJStateIdNo3;
        formData.CaregiverDOB3 = this.state.caregiverDOB3;
        formData.CaregiverRelationship3 = this.state.CaregiverRelationship3;
        formData.CaregiverPhone3 = this.state.caregiverPhone3;
        formData.CaregiverEmail3 = this.state.caregiverEmail3;
        formData.CaregiverNotes3 = this.state.caregiverNotes3;

        formData.CaregiverName4 = this.state.caregiverName4;
        formData.CaregiverMJStateIdNo4 = this.state.CaregiverMJStateIdNo4;
        formData.CaregiverDOB4 = this.state.caregiverDOB4;
        formData.CaregiverRelationship4 = this.state.CaregiverRelationship4;
        formData.CaregiverPhone4 = this.state.caregiverPhone4;
        formData.CaregiverEmail4 = this.state.caregiverEmail4;
        formData.CaregiverNotes4 = this.state.caregiverNotes4;

        formData.CaregiverName5 = this.state.caregiverName5;
        formData.CaregiverMJStateIdNo5 = this.state.CaregiverMJStateIdNo5;
        formData.CaregiverDOB5 = this.state.caregiverDOB5;
        formData.CaregiverRelationship5 = this.state.CaregiverRelationship5;
        formData.CaregiverPhone5 = this.state.caregiverPhone5;
        formData.CaregiverEmail5 = this.state.caregiverEmail5;
        formData.CaregiverNotes5 = this.state.caregiverNotes5;

        formData.CaregiverName6 = this.state.caregiverName6;
        formData.CaregiverMJStateIdNo6 = this.state.CaregiverMJStateIdNo6;
        formData.CaregiverDOB6 = this.state.caregiverDOB6;
        formData.CaregiverRelationship6 = this.state.CaregiverRelationship6;
        formData.CaregiverPhone6 = this.state.caregiverPhone6;
        formData.CaregiverEmail6 = this.state.caregiverEmail6;
        formData.CaregiverNotes6 = this.state.caregiverNotes6;

        formData.Attestation = this.state.attestation;
        formData.AttestationSignedDate = this.state.attestationSignedDate;
        formData.AttestationExpirationDate = this.state.attestationExpirationDate;

        formData.Guardian = this.state.guardian;
        formData.PrimaryQualifyingConditionId = this.state.PrimaryQualifyingConditionId;
        formData.SecondaryQualifyingConditionIds = this.state.SecondaryQualifyingConditionIds;

        return formData;
    }

    getDoctorByTitle(title) {
        var doctors = this.state.list_of_doctors;

        for (var i=0; i<doctors.length; i++)
            if (title === doctors[i].DoctorsName)
                return doctors[i].Id;

        return 0;
    }

    onAttestationChange(field, val) {
        var self = this;

        this.setState({
            attestation : val,
        }, () => {
            AjaxPromises.POST(GuestEndPoints.SET_ATTESTATION, UserStore.getApiData({
                GuestId : self.props.guest.Guest_id,
                Attestation : val,
            })).then(res => {
                if (res.Result) {
                    NotificationActions.success('Attestation Updated')
                    GuestActions.loadFullGuest(self.props.guest.Guest_id);
                }
            });
        });
    }

    AddSecondaryCondition(toAdd) {
        var conditions = this.state.SecondaryQualifyingConditionIds.concat([parseInt(toAdd)]);

        this.setState({SecondaryQualifyingConditionIds: _.uniq(conditions)});
    }

    RemoveSecondaryCondition(toRemove) {
        var conditions = this.state.SecondaryQualifyingConditionIds.filter(c => c != toRemove);

        this.setState({SecondaryQualifyingConditionIds: _.uniq(conditions)});
    }

    setPrimary(caregiver) {
        AjaxPromises.POST(GuestListEndPoints.SELECT_COLLECTOR, UserStore.getApiData({
            CustomerId : this.props.guest.Guest_id,
            CaregiverMJStateIdNo: caregiver.id,
            CaregiverName: caregiver.name,
            CaregiverRelationship: caregiver.relationship,
            CaregiverDob: caregiver.DOB,
            CaregiverEmail: caregiver.email,
            CaregiverPhone: caregiver.phone,
            CaregiverNotes: caregiver.notes,
        })).then(res => {
            if (res.Result) {
                GuestActions.loadFullGuest(this.props.guest.Guest_id);
                NotificationActions.success('Primary collector updated')
            } else {
                NotificationActions.error('Primary collector could not be updated');
            }
        });
    }

    isCollectorValid(collectorNumber) {
        return !!this.state[`CaregiverMJStateIdNo${collectorNumber}`] &&
            !!this.state[`caregiverDOB${collectorNumber}`] &&
            !!this.state[`CaregiverRelationship${collectorNumber}`] &&
            !!this.state[`caregiverName${collectorNumber}`]
    }

    viewPrescriptions() {
        if (!Number(this.props.guest.doctor)) {
            NotificationActions.error('A doctor must be assigned and saved to the patient profile before you can enter prescription manager');
            return;
        }

        if (this.state.managePrescriptions) {
            this.setState({ managePrescriptions: false });
        } else {
            this.setState({ managePrescriptions: true });
        }
    }

    render() {
        var guest = this.props.guest;
        var page = this.props.page;
        var selectedLocation = this.props.selectedLocation;

        if (page !== 'medical')
            return null;

        var secondaryConditions = this.state.SecondaryQualifyingConditionIds.map(secondaryId => 
            this.state.list_of_all_qualified_conditions.find(qc => 
                qc.QualifyingConditionId == secondaryId)
        ).filter(qc => !!qc);

        let relationshipOptions = [
            { title: '-', option: ''},
            { title: 'Parent/Legal Guardian', option: 'PLG' },
            { title: 'Caregiver', option: 'CAREGIVER' },
        ];

        return (
            <div className='container'>
                { selectedLocation.CompanyFlag === 'Dispensary' && [
                    <Header label='Doctor' first={true} />,

                    <PageRow title='Doctors Name'>
                        <DD
                            value={this.state.doctor}
                            disabled={guest.IsAnonymous}
                            onChange={doctor => { this.setState({ doctor }); }}
                            options={[{ title: '-', option: undefined }]
                                .concat(this.state.list_of_doctors.map(x => {
                                    return { title: x.DoctorsName, option: x.Id };
                                }))
                                .concat({ title: 'Refresh', option: 'Refresh' })
                            }
                            onRefresh={() => { this.loadListOfDoctors(true); }} />
                    </PageRow>,
                    <div>
                        { selectedLocation.PrescriptionManager &&
                            <PageRow>
                                <button className='btn-green'
                                        onClick={this.viewPrescriptions}>
                                    Manage Prescriptions
                                </button>
                            </PageRow>
                        }
                    </div>,
                    <div>
                        { this.state.managePrescriptions &&
                            <div className='popup popup__transparent'>
                                <div className='popup__content manage-prescriptions'>
                                    <div className='popup-header'>
                                        MANAGE PRESCRIPTIONS
                                        <div
                                            className='popup-close'
                                            onClick={ this.viewPrescriptions }>

                                            <i className='fa fa-times' aria-hidden='true' />
                                        </div>
                                    </div>
                                    <Prescriptions guest={guest} />
                                </div>
                            </div>
                        }
                    </div>,
                    <div>
                        {!UserStore.isFieldHidden(CustomerProfilePOS, 'PrimaryQualifyingConditionId') &&
                            <div>
                                <Header label='Qualifying Conditions' />

                                <PageRow title={`Primary Condition ${UserStore.isFieldRequired(CustomerProfilePOS, 'PrimaryQualifyingConditionId') ? '*' : ''}`}>
                                    <DD
                                        value={this.state.PrimaryQualifyingConditionId}
                                        disabled={guest.IsAnonymous}
                                        onChange={PrimaryQualifyingConditionId => { this.setState({ PrimaryQualifyingConditionId }); }}
                                        options={[{ title: '-', option: undefined }]
                                            .concat(this.state.list_of_primary_qualified_conditions.map(x => {
                                                return { title: x.Name, option: x.QualifyingConditionId };
                                            }))
                                            .concat({ title: 'Refresh', option: 'Refresh' })
                                        }
                                        onRefresh={() => { this.loadQualifiedConditions(true); }}
                                    />
                                </PageRow>
                                <PageRow title='Secondary Conditions'>
                                    <Picklist
                                        disabled={guest.IsAnonymous}
                                        values={secondaryConditions.map(x => {
                                            return { title: x.Name, option: x.QualifyingConditionId };
                                        })}
                                        onChange={SecondaryQualifyingConditionIds => { this.AddSecondaryCondition(SecondaryQualifyingConditionIds); }}
                                        options={this.state.list_of_secondary_qualified_conditions.map(x => {
                                                return { title: x.Name, option: x.QualifyingConditionId };
                                            })}
                                        OnRemove={(v) => { this.RemoveSecondaryCondition(v) }}
                                        />                       
                                </PageRow>
                            </div>
                        }
                    </div>
                ]}

                { selectedLocation.Attestation &&
                    <Header label='Attestation Form Completed' />
                }
                { selectedLocation.Attestation &&
                    <div>
                        <div className='row'>
                            <div className='col-6'>
                                <DropdownProfile
                                    field='attestation'
                                    disabled={guest.IsAnonymous}
                                    options={
                                    [
                                        { title: 'No', option: 'no'},
                                        { title: 'Yes', option: 'yes' },
                                    ]
                                    }
                                    selected={this.state.attestation}
                                    onChange={this.onAttestationChange} />
                            </div>
                            <div className='col-6'>
                                <div className='profile-main__label'>
                                    Attestation
                                </div>
                            </div>
                        </div>
                        {(this.state.attestation).toLowerCase() === 'yes' &&
                            <div>
                                <div className='row'>
                                    <div className='col-6 mb-2'>
                                        <DOB
                                            AllowInFuture
                                            field='attestationSignedDate'
                                            value={this.state.attestationSignedDate}
                                            onChange={this.onChange}
                                        />
                                    </div>
                                    <div className='col-6'>
                                        <div className='profile-main__label'>
                                            Attestation Date Signed
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-6'>
                                        <DOB
                                            AllowInFuture
                                            field='attestationExpirationDate'
                                            value={this.state.attestationExpirationDate}
                                            onChange={this.onChange}
                                        />
                                    </div>
                                    <div className='col-6'>
                                        <div className='profile-main__label'>
                                            Attestation Date Expires
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                }

                { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <Header label={`Primary ${selectedLocation.UseMn ? 'Collector' : 'Caregiver'}`} first={false} />
                }
                { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <InputProfile
                                field='CGFirstName'
                                disabled={selectedLocation.UseMn || guest.IsAnonymous}
                                value={this.state.CGFirstName}
                                onChange={this.onChange}
                                placeHolder='First Name' />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                First Name
                            </div>
                        </div>
                    </div>
                }
                
                { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <InputProfile
                                field='CGLastName'
                                disabled={selectedLocation.UseMn || guest.IsAnonymous}
                                value={this.state.CGLastName}
                                onChange={this.onChange}
                                placeHolder='Last Name' />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Last Name
                            </div>
                        </div>
                    </div>
                }
                { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <InputProfile
                                field='CaregiverMJStateIdNo'
                                disabled={selectedLocation.UseMn || guest.IsAnonymous}
                                value={this.state.CaregiverMJStateIdNo}
                                onChange={this.onChange}
                                placeHolder='MJ State Id' />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                MJ State Id
                            </div>
                        </div>
                    </div>
                }
                { (selectedLocation.CompanyFlag === 'Dispensary' && selectedLocation.MJIDStartDateField) &&
                    <div className='row'>
                        <div className='col-6'>
                            <DOB
                                AllowInFuture
                                field='CaregiverStartDate'
                                disabled={guest.IsAnonymous}
                                value={this.state.CaregiverStartDate}
                                onChange={this.onChange}
                                 />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                            MJ Id Start Date
                            </div>
                        </div>
                    </div>
                }

                { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <DOB
                                AllowInFuture
                                field='CaregiverExpirationDate'
                                disabled={guest.IsAnonymous}
                                value={this.state.CaregiverExpirationDate}
                                onChange={this.onChange}
                                 />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                            MJ Id Expiration Date
                            </div>
                        </div>
                    </div>
                }

                {!UserStore.isFieldHidden(CustomerProfilePOS, 'CaregiverAddress1') && selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <InputProfile
                                field='CaregiverAddress'
                                disabled={selectedLocation.UseMn || guest.IsAnonymous}
                                value={this.state.CaregiverAddress}
                                onChange={this.onChange}
                                placeHolder='Address 1' />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Address 1 {UserStore.isFieldRequired(CustomerProfilePOS, 'CaregiverAddress1') ? '*' : ''}
                            </div>
                        </div>
                    </div>
                }

                {!UserStore.isFieldHidden(CustomerProfilePOS, 'CaregiverAddress2') && selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <InputProfile
                                field='CaregiverAddress2'
                                disabled={selectedLocation.UseMn || guest.IsAnonymous}
                                value={this.state.CaregiverAddress2}
                                onChange={this.onChange}
                                placeHolder='Address 2' />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Address 2 {UserStore.isFieldRequired(CustomerProfilePOS, 'CaregiverAddress2') ? '*' : ''}
                            </div>
                        </div>
                    </div>
                }

                {!UserStore.isFieldHidden(CustomerProfilePOS, 'CaregiverAddress3') && selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <InputProfile
                                field='CaregiverAddress3'
                                disabled={selectedLocation.UseMn || guest.IsAnonymous}
                                value={this.state.CaregiverAddress3}
                                onChange={this.onChange}
                                placeHolder='Address 3' />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Address 3 {UserStore.isFieldRequired(CustomerProfilePOS, 'CaregiverAddress3') ? '*' : ''}
                            </div>
                        </div>
                    </div>
                }

                {!UserStore.isFieldHidden(CustomerProfilePOS, 'CaregiverCity') &&  selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <InputProfile
                                field='CaregiverCity'
                                disabled={selectedLocation.UseMn || guest.IsAnonymous}
                                value={this.state.CaregiverCity}
                                onChange={this.onChange}
                                placeHolder='City' />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                City {UserStore.isFieldRequired(CustomerProfilePOS, 'CaregiverCity') ? '*' : ''}
                            </div>
                        </div>
                    </div>
                }

                {!UserStore.isFieldHidden(CustomerProfilePOS, 'CaregiverState') &&  selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <DropdownProfileStates
                                field='CaregiverState'
                                disabled={selectedLocation.UseMn || guest.IsAnonymous}
                                selected={this.state.CaregiverState}
                                onChange={this.onChange}/>
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                State {UserStore.isFieldRequired(CustomerProfilePOS, 'CaregiverState') ? '*' : ''}
                            </div>
                        </div>
                    </div>
                }

                {!UserStore.isFieldHidden(CustomerProfilePOS, 'CaregiverPostalCode') &&  selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <InputProfile
                                field='CaregiverPostalCode'
                                disabled={selectedLocation.UseMn || guest.IsAnonymous}
                                value={this.state.CaregiverPostalCode}
                                onChange={this.onChange}
                                placeHolder='Postal Code' />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Postal Code {UserStore.isFieldRequired(CustomerProfilePOS, 'CaregiverPostalCode') ? '*' : ''}
                            </div>
                        </div>
                    </div>
                }

                { selectedLocation.UseMn  &&

                    <div className='row'>
                        <div className='col-6 input-profile__disabled'>
                            <DD
                                required
                                disabled
                                value={this.state.CaregiverRelationship}
                                onChange={CaregiverRelationship => { this.setState({ CaregiverRelationship }); }}
                                options={relationshipOptions} />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Relationship
                            </div>
                        </div>
                    </div>
                    
                }

                { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <InputProfile
                                field='CaregiverPhone'
                                disabled={guest.IsAnonymous}
                                value={Utils.formatPhoneNumber(this.state.CaregiverPhone)}
                                onChange={(field, value) => { this.onChange(field, value.replace(/[^0-9]/g, '')); }}
                                placeHolder='Phone Number' />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Phone Number
                            </div>
                        </div>
                    </div>
                }
                { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <InputProfile
                                field='caregiverEmail'
                                disabled={guest.IsAnonymous}
                                value={this.state.caregiverEmail}
                                onChange={(field, value) => { this.onChange(field, value); }}
                                placeHolder='Email' />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Email
                            </div>
                        </div>
                    </div>
                }
                { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <DOB
                                field='CaregiverDOB'
                                disabled={guest.IsAnonymous}
                                value={this.state.CaregiverDOB}
                                onChange={this.onChange} />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                DOB
                            </div>
                        </div>
                    </div>
                }
                { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <TextareaProfile
                                field='caregiverNotes'
                                disabled={guest.IsAnonymous}
                                value={this.state.caregiverNotes}
                                onChange={this.onChange} />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Notes
                            </div>
                        </div>
                    </div>
                }

                { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <Header label={`Additional ${selectedLocation.UseMn ? 'Collectors' : 'Caregivers'}`} first={false} />
                }
                { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <InputProfile
                                field='caregiverName2'
                                disabled={guest.IsAnonymous}
                                value={this.state.caregiverName2}
                                onChange={this.onChange}
                                placeHolder='Name' />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Name
                            </div>
                        </div>
                    </div>
                }
                { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <DOB
                                field='caregiverDOB2'
                                disabled={guest.IsAnonymous}
                                value={this.state.caregiverDOB2}
                                onChange={this.onChange} />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                DOB
                            </div>
                        </div>
                    </div>
                }
                { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <InputProfile
                                field='CaregiverMJStateIdNo2'
                                disabled={guest.IsAnonymous}
                                value={this.state.CaregiverMJStateIdNo2}
                                onChange={this.onChange}
                                placeHolder='Identification Number' />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Id #
                            </div>
                        </div>
                    </div>
                }

                { selectedLocation.UseMn  &&

                    <div className='row'>
                        <div className='col-6 input-profile'>
                            <DD
                                required
                                disabled={guest.IsAnonymous}
                                value={this.state.CaregiverRelationship2}
                                onChange={CaregiverRelationship2 => { this.setState({ CaregiverRelationship2 }); }}
                                options={relationshipOptions} />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Relationship
                            </div>
                        </div>
                    </div>

                }

                { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <InputProfile
                                field='caregiverPhone2'
                                disabled={guest.IsAnonymous}
                                value={Utils.formatPhoneNumber(this.state.caregiverPhone2)}
                                onChange={(field, value) => { this.onChange(field, value.replace(/[^0-9]/g, '')); }}
                                placeHolder='Phone Number' />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Phone Number
                            </div>
                        </div>
                    </div>
                }
                { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <InputProfile
                                field='caregiverEmail2'
                                disabled={guest.IsAnonymous}
                                value={this.state.caregiverEmail2}
                                onChange={(field, value) => { this.onChange(field, value); }}
                                placeHolder='Email' />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Email
                            </div>
                        </div>
                    </div>
                }
                { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <TextareaProfile
                                field='caregiverNotes2'
                                disabled={guest.IsAnonymous}
                                value={this.state.caregiverNotes2}
                                onChange={this.onChange} />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Notes
                            </div>
                        </div>
                    </div>
                }
                {/* { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <button
                                disabled={!this.isCollectorValid('2')}
                                className={`btn-green ${this.isCollectorValid('2') ? '' : 'btn-green__disabled'}`}
                                onClick={() => this.setPrimary({
                                        name: this.state.caregiverName2, 
                                        id: this.state.CaregiverMJStateIdNo2, 
                                        relationship: this.state.CaregiverRelationship2, 
                                        DOB: this.state.caregiverDOB2, 
                                        email: this.state.caregiverEmail2, 
                                        phone: this.state.caregiverPhone2, 
                                        notes: this.state.caregiverNotes2,
                                })} >
                                    Set Primary
                            </button>
                        </div>
                    </div>
                } */}
                { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <hr />
                }
                { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <InputProfile
                                field='caregiverName3'
                                disabled={guest.IsAnonymous}
                                value={this.state.caregiverName3}
                                onChange={this.onChange}
                                placeHolder='Name' />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Name
                            </div>
                        </div>
                    </div>
                }
                { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <DOB
                                field='caregiverDOB3'
                                disabled={guest.IsAnonymous}
                                value={this.state.caregiverDOB3}
                                onChange={this.onChange} />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                DOB
                            </div>
                        </div>
                    </div>
                }
                { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <InputProfile
                                field='CaregiverMJStateIdNo3'
                                disabled={guest.IsAnonymous}
                                value={this.state.CaregiverMJStateIdNo3}
                                onChange={this.onChange}
                                placeHolder='Identification Number' />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Id #
                            </div>
                        </div>
                    </div>
                }
                { selectedLocation.UseMn  &&

                    <div className='row'>
                        <div className='col-6 input-profile'>
                            <DD
                                required
                                disabled={guest.IsAnonymous}
                                value={this.state.CaregiverRelationship3}
                                onChange={CaregiverRelationship3 => { this.setState({ CaregiverRelationship3 }); }}
                                options={relationshipOptions} />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Relationship
                            </div>
                        </div>
                    </div>

                }
                { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <InputProfile
                                field='caregiverPhone3'
                                disabled={guest.IsAnonymous}
                                value={Utils.formatPhoneNumber(this.state.caregiverPhone3)}
                                onChange={(field, value) => { this.onChange(field, value.replace(/[^0-9]/g, '')); }}
                                placeHolder='Phone Number' />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Phone Number
                            </div>
                        </div>
                    </div>
                }
                { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <InputProfile
                                field='caregiverEmail3'
                                disabled={guest.IsAnonymous}
                                value={this.state.caregiverEmail3}
                                onChange={(field, value) => { this.onChange(field, value); }}
                                placeHolder='Email' />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Email
                            </div>
                        </div>
                    </div>
                }
                { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <TextareaProfile
                                field='caregiverNotes3'
                                disabled={guest.IsAnonymous}
                                value={this.state.caregiverNotes3}
                                onChange={this.onChange} />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Notes
                            </div>
                        </div>
                    </div>
                }
                {/* { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <button
                                disabled={!this.isCollectorValid('3')}
                                className={`btn-green ${this.isCollectorValid('3') ? '' : 'btn-green__disabled'}`}
                                onClick={() => this.setPrimary({
                                    name: this.state.caregiverName3, 
                                    id: this.state.CaregiverMJStateIdNo3, 
                                    relationship: this.state.CaregiverRelationship3, 
                                    DOB: this.state.caregiverDOB3, 
                                    email: this.state.caregiverEmail3, 
                                    phone: this.state.caregiverPhone3, 
                                    notes: this.state.caregiverNotes3,
                                })} >
                                    Set Primary
                            </button>
                        </div>
                    </div>
                } */}
                { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <hr />
                }
                { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <InputProfile
                                field='caregiverName4'
                                disabled={guest.IsAnonymous}
                                value={this.state.caregiverName4}
                                onChange={this.onChange}
                                placeHolder='Name' />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Name
                            </div>
                        </div>
                    </div>
                }
                { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <DOB
                                field='caregiverDOB4'
                                disabled={guest.IsAnonymous}
                                value={this.state.caregiverDOB4}
                                onChange={this.onChange} />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                DOB
                            </div>
                        </div>
                    </div>
                }
                { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <InputProfile
                                field='CaregiverMJStateIdNo4'
                                disabled={guest.IsAnonymous}
                                value={this.state.CaregiverMJStateIdNo4}
                                onChange={this.onChange}
                                placeHolder='Identification Number' />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Id #
                            </div>
                        </div>
                    </div>
                }
                { selectedLocation.UseMn  &&

                <div className='row'>
                    <div className='col-6 input-profile'>
                        <DD
                            required
                            disabled={guest.IsAnonymous}
                            value={this.state.CaregiverRelationship4}
                            onChange={CaregiverRelationship4 => { this.setState({ CaregiverRelationship4 }); }}
                            options={relationshipOptions} />
                    </div>
                    <div className='col-6'>
                        <div className='profile-main__label'>
                            Relationship
                        </div>
                    </div>
                </div>

                }
                { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <InputProfile
                                field='caregiverPhone4'
                                disabled={guest.IsAnonymous}
                                value={Utils.formatPhoneNumber(this.state.caregiverPhone4)}
                                onChange={(field, value) => { this.onChange(field, value.replace(/[^0-9]/g, '')); }}
                                placeHolder='Phone Number' />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Phone Number
                            </div>
                        </div>
                    </div>
                }
                { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <InputProfile
                                field='caregiverEmail4'
                                disabled={guest.IsAnonymous}
                                value={this.state.caregiverEmail4}
                                onChange={(field, value) => { this.onChange(field, value); }}
                                placeHolder='Email' />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Email
                            </div>
                        </div>
                    </div>
                }
                { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <TextareaProfile
                                field='caregiverNotes4'
                                disabled={guest.IsAnonymous}
                                value={this.state.caregiverNotes4}
                                onChange={this.onChange} />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Notes
                            </div>
                        </div>
                    </div>
                }
                {/* { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <button
                                disabled={!this.isCollectorValid('4')}
                                className={`btn-green ${this.isCollectorValid('4') ? '' : 'btn-green__disabled'}`}
                                onClick={() => this.setPrimary({
                                    name: this.state.caregiverName4, 
                                    id: this.state.CaregiverMJStateIdNo4, 
                                    relationship: this.state.CaregiverRelationship4, 
                                    DOB: this.state.caregiverDOB4, 
                                    email: this.state.caregiverEmail4, 
                                    phone: this.state.caregiverPhone4, 
                                    notes: this.state.caregiverNotes4,
                                })} >
                                    Set Primary
                            </button>
                        </div>
                    </div>
                } */}
                { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <hr />
                }
                { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <InputProfile
                                field='caregiverName5'
                                disabled={guest.IsAnonymous}
                                value={this.state.caregiverName5}
                                onChange={this.onChange}
                                placeHolder='Name' />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Name
                            </div>
                        </div>
                    </div>
                }
                { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <DOB
                                field='caregiverDOB5'
                                disabled={guest.IsAnonymous}
                                value={this.state.caregiverDOB5}
                                onChange={this.onChange} />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                DOB
                            </div>
                        </div>
                    </div>
                }
                { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <InputProfile
                                field='CaregiverMJStateIdNo5'
                                disabled={guest.IsAnonymous}
                                value={this.state.CaregiverMJStateIdNo5}
                                onChange={this.onChange}
                                placeHolder='Identification Number' />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Id #
                            </div>
                        </div>
                    </div>
                }
                { selectedLocation.UseMn  &&

                    <div className='row'>
                        <div className='col-6 input-profile'>
                            <DD
                                required
                                disabled={guest.IsAnonymous}
                                value={this.state.CaregiverRelationship5}
                                onChange={CaregiverRelationship5 => { this.setState({ CaregiverRelationship5 }); }}
                                options={relationshipOptions} />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Relationship
                            </div>
                        </div>
                    </div>

                }
                { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <InputProfile
                                field='caregiverPhone5'
                                disabled={guest.IsAnonymous}
                                value={Utils.formatPhoneNumber(this.state.caregiverPhone5)}
                                onChange={(field, value) => { this.onChange(field, value.replace(/[^0-9]/g, '')); }}
                                placeHolder='Phone Number' />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Phone Number
                            </div>
                        </div>
                    </div>
                }
                { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <InputProfile
                                field='caregiverEmail5'
                                disabled={guest.IsAnonymous}
                                value={this.state.caregiverEmail5}
                                onChange={(field, value) => { this.onChange(field, value); }}
                                placeHolder='Email' />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Email
                            </div>
                        </div>
                    </div>
                }
                { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <TextareaProfile
                                field='caregiverNotes5'
                                disabled={guest.IsAnonymous}
                                value={this.state.caregiverNotes5}
                                onChange={this.onChange} />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Notes
                            </div>
                        </div>
                    </div>
                }
                {/* { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <button
                                disabled={!this.isCollectorValid('5')}
                                className={`btn-green ${this.isCollectorValid('5') ? '' : 'btn-green__disabled'}`}
                                onClick={() => this.setPrimary({
                                    name: this.state.caregiverName5, 
                                    id: this.state.CaregiverMJStateIdNo5, 
                                    relationship: this.state.CaregiverRelationship5, 
                                    DOB: this.state.caregiverDOB5, 
                                    email: this.state.caregiverEmail5, 
                                    phone: this.state.caregiverPhone5, 
                                    notes: this.state.caregiverNotes5,
                                })} >
                                    Set Primary
                            </button>
                        </div>
                    </div>
                } */}
                { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <hr />
                }
                { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <InputProfile
                                field='caregiverName6'
                                disabled={guest.IsAnonymous}
                                value={this.state.caregiverName6}
                                onChange={this.onChange}
                                placeHolder='Name' />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Name
                            </div>
                        </div>
                    </div>
                }
                { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <DOB
                                field='caregiverDOB6'
                                disabled={guest.IsAnonymous}
                                value={this.state.caregiverDOB6}
                                onChange={this.onChange} />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                DOB
                            </div>
                        </div>
                    </div>
                }
                { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <InputProfile
                                field='CaregiverMJStateIdNo6'
                                disabled={guest.IsAnonymous}
                                value={this.state.CaregiverMJStateIdNo6}
                                onChange={this.onChange}
                                placeHolder='Identification Number' />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Id #
                            </div>
                        </div>
                    </div>
                }
                { selectedLocation.UseMn  &&

                    <div className='row'>
                        <div className='col-6 input-profile'>
                            <DD
                                required
                                disabled={guest.IsAnonymous}
                                value={this.state.CaregiverRelationship6}
                                onChange={CaregiverRelationship6 => { this.setState({ CaregiverRelationship6 }); }}
                                options={
                                    relationshipOptions
                                } />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Relationship
                            </div>
                        </div>
                    </div>

                    }
                { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <InputProfile
                                field='caregiverPhone6'
                                disabled={guest.IsAnonymous}
                                value={Utils.formatPhoneNumber(this.state.caregiverPhone6)}
                                onChange={(field, value) => { this.onChange(field, value.replace(/[^0-9]/g, '')); }}
                                placeHolder='Phone Number' />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Phone Number
                            </div>
                        </div>
                    </div>
                }
                { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <InputProfile
                                field='caregiverEmail6'
                                disabled={guest.IsAnonymous}
                                value={this.state.caregiverEmail6}
                                onChange={(field, value) => { this.onChange(field, value); }}
                                placeHolder='Email' />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Email
                            </div>
                        </div>
                    </div>
                }
                { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <TextareaProfile
                                field='caregiverNotes6'
                                disabled={guest.IsAnonymous}
                                value={this.state.caregiverNotes6}
                                onChange={this.onChange} />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Notes
                            </div>
                        </div>
                    </div>
                }
                {/* { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <div className='row'>
                        <div className='col-6'>
                            <button
                                disabled={!this.isCollectorValid('6')}
                                className={`btn-green ${this.isCollectorValid('6') ? '' : 'btn-green__disabled'}`}
                                onClick={() => this.setPrimary({
                                    name: this.state.caregiverName6, 
                                    id: this.state.CaregiverMJStateIdNo6, 
                                    relationship: this.state.CaregiverRelationship6, 
                                    DOB: this.state.caregiverDOB6, 
                                    email: this.state.caregiverEmail6, 
                                    phone: this.state.caregiverPhone6, 
                                    notes: this.state.caregiverNotes6,
                                })} >
                                    Set Primary
                            </button>
                        </div>
                    </div>
                } */}
                { selectedLocation.CompanyFlag === 'Dispensary' && 
                !selectedLocation.UseMn && //MN uses the primary caregiver field for PLG
                                            //For state reporting purposes
                    [
                        <Header label='Guardian' first={false} />,
                    
                    
                        <div className='row'>
                            <div className='col-6'>
                                <InputProfile
                                    field='guardian'
                                    disabled={guest.IsAnonymous}
                                    value={this.state.guardian}
                                    onChange={this.onChange}
                                    placeHolder='Guardian Name' />
                            </div>
                            <div className='col-6'>
                                <div className='profile-main__label'>
                                    Name of Guardian
                                </div>
                            </div>
                        </div>,
                    ]
                }

                <div className='row'>
                    <div className='col-12'>
                        <div className='row'>
                            <div className='col-6'>
                                <div className='profile-main__container--header'>
                                    Notes
                                </div>
                            </div>
                            <div className='col-6'>
                                <div className='profile-main__container--header'>
                                    Vouchers and Referrals
                                </div>
                            </div>
                        </div>

                        <div className='row'>
                            <div className='col-6'>
                                <TextareaProfile
                                    field='notes'
                                    disabled={guest.IsAnonymous}
                                    value={this.state.notes}
                                    onChange={this.onChange} />
                            </div>
                            <div className='col-6'>
                                <TextareaProfile
                                    field='creditNote'
                                    disabled={guest.IsAnonymous}
                                    value={this.state.creditNote}
                                    onChange={this.onChange} />
                            </div>
                        </div>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-12'>
                        <div className='row'>
                            <div className='col-6'>
                                <div className='profile-main__container--header'>
                                    Conditions
                                </div>
                            </div>
                            <div className='col-6'>

                            </div>
                        </div>

                        <div className='row'>
                            <div className='col-6'>
                                <TextareaProfile
                                    field='conditions'
                                    disabled={guest.IsAnonymous}
                                    value={this.state.conditions}
                                    onChange={this.onChange} />
                            </div>
                            <div className='col-6'>

                            </div>
                        </div>
                    </div>
                </div>

                { selectedLocation.CompanyFlag === 'Dispensary' &&
                    <Header label='Documents' first={false} />
                }

            </div>
        );
    }
}

export default ViewMedical;



// WEBPACK FOOTER //
// ./ui_src/app/components/profile/view/ViewMedical.react.jsx